import { Link } from 'react-router-dom';
import { ASSETS, BRAND, CLOSING_STATEMENT } from '../lib/content';
import { Mail, Leaf } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-bg-soft border-t border-brand-brown/5 mt-24">
      <div className="max-w-4xl mx-auto px-6 md:px-12 pt-20 pb-4 text-center" data-testid="footer-closing">
        <div className="divider-leaf mb-8" />
        <p className="font-serif italic text-lg md:text-xl text-brand-brown-light leading-relaxed">
          {CLOSING_STATEMENT.body}
        </p>
        <p className="mt-6 font-serif italic text-xl md:text-2xl text-brand-gold tracking-wide">
          {CLOSING_STATEMENT.strapline}
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={ASSETS.logo} alt="" className="h-12 w-12 rounded-full logo-blend object-cover" />
            <div>
              <div className="font-serif text-xl">Nurture the Self</div>
              <div className="font-sans text-[11px] uppercase tracking-[0.22em] text-brand-brown-muted">a therapeutic pathway</div>
            </div>
          </div>
          <p className="font-sans text-sm text-brand-brown-light/90 leading-relaxed max-w-sm">
            A year-long, three-part therapeutic journey supporting individuals to heal their relationship with food, body and self — with care, with rhythm, with reverence.
          </p>
          <p className="mt-5 font-serif italic text-base text-brand-gold">{BRAND.strapline}</p>
        </div>

        <div>
          <h4 className="font-serif text-xl mb-5">Find your way</h4>
          <ul className="space-y-3 font-sans text-sm text-brand-brown-light">
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-brand-brown">About</Link></li>
            <li><Link to="/courses" data-testid="footer-link-courses" className="hover:text-brand-brown">The Three Paths</Link></li>
            <li><Link to="/retreats" data-testid="footer-link-retreats" className="hover:text-brand-brown">Workshops & Retreats</Link></li>
            <li><Link to="/facilitators" data-testid="footer-link-facilitators" className="hover:text-brand-brown">Facilitators</Link></li>
            <li><Link to="/therapy" data-testid="footer-link-therapy" className="hover:text-brand-brown">One-to-One Therapy</Link></li>
            <li><Link to="/investment" data-testid="footer-link-investment" className="hover:text-brand-brown">Your Journey</Link></li>
            <li><Link to="/booking" data-testid="footer-link-booking" className="hover:text-brand-brown">Booking</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-xl mb-5">Reach out</h4>
          <a
            href="mailto:aboutnurturetheself@gmail.com"
            data-testid="footer-email"
            className="font-sans text-sm text-brand-brown-light hover:text-brand-brown inline-flex items-center gap-2"
          >
            <Mail size={16} /> aboutnurturetheself@gmail.com
          </a>
          <p className="font-sans text-xs text-brand-brown-muted mt-6 leading-relaxed">
            Information shared with us is held securely and treated with care, in line with GDPR principles. It will never be shared with third parties without your consent.
          </p>
        </div>
      </div>

      <div className="border-t border-brand-brown/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-sans text-xs text-brand-brown-muted flex items-center gap-2">
            <Leaf size={14} className="text-brand-sage-dark" />
            © {new Date().getFullYear()} Nurture the Self. Held with care.
          </div>
          <div className="font-sans text-xs text-brand-brown-muted">
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-brand-brown">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
